"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _effects = require("redux-saga/effects");

var _redux = require("./utils/redux");

var createSaga = function createSaga() {
  var generator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.requestGenerator;
  var taker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _effects.takeLatest;
  return function (action) {
    return taker(action.type, generator, action);
  };
};

var _default = createSaga;
exports["default"] = _default;